import { LitElement, html } from 'lit';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { customElement } from 'lit/decorators.js';
import Layout from 'utils/layout';
import Slider from '../../slider';

@customElement('product-zoom-modal')
class ProductZoomModal extends LitElement {
  constructor() {
    super();
    this.thumbsSliderEl = this.querySelector(
      '[data-product-zoom-gallery-thumbs]',
    );
    this.mainSliderEl = this.querySelector('[data-product-zoom-gallery-main]');
    this.closeZoomButtons = this.querySelectorAll('[data-close-zoom-button]');
    this.thumbsSliderInstance = null;
    this.mainSliderInstance = null;
    this.initialIndex = 0;
    this.layoutInstance = Layout.getInstance();

    this.thumbsSliderOptions = {
      direction: 'vertical',
      slidesPerView: 6,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      spaceBetween: 6,
    };

    this.mainSliderOptions = {
      effect: 'fade',
    };

    this.closeZoomButtons.forEach((button) => {
      button.addEventListener('click', this.closeModal);
    });
  }

  connectedCallback() {
    super.connectedCallback();
    this._initThumbsSlider();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.thumbsSliderInstance.unload();
    this.mainSliderInstance.unload();
    this.closeZoomButtons.forEach((button) => {
      button.removeEventListener('click', this.closeModal);
    });
  }

  _initThumbsSlider = () => {
    this.thumbsSliderInstance = new Slider({
      el: this.thumbsSliderEl,
      options: {
        ...this.thumbsSliderOptions,
      },
    });
    this._initMainSlider();
  };

  openModal = (index) => {
    this.initialIndex = index;
    this.mainSliderInstance.swiper.slideTo(index);
    disableBodyScroll(this);
    this.classList.remove('hidden');
    if (this.layoutInstance.isBelowBreakpoint('md')) {
      const currentMedia = this.querySelector(`[data-media-index="${index}"]`);
      currentMedia.scrollIntoView({ behavior: 'smooth' });
    }
  };

  closeModal = () => {
    enableBodyScroll(this);
    this.classList.add('hidden');
  };

  _initMainSlider = () => {
    this.mainSliderInstance = new Slider({
      el: this.mainSliderEl,
      options: {
        ...this.mainSliderOptions,
        thumbs: {
          swiper: this.thumbsSliderInstance.swiper,
        },
      },
    });
  };

  render() {
    return html`<slot></slot>`;
  }
}

export default ProductZoomModal;
